import { OfficeArrayOfUpdateIdTokenType } from '@/@types/cognito'
import { KumasanAuth } from '@/cognito/index'
import sessionStorageUtils from '@/lib/sessionStrage/session-strage-utils'
import { handleUnGzipData } from '@/lib/api/use-get-data'

export default {
  getSelectOfficeArray(
    officeArrayOfUpdateIdToken: OfficeArrayOfUpdateIdTokenType[]
  ) {
    const selectOfficeArray = officeArrayOfUpdateIdToken.map(
      (office: OfficeArrayOfUpdateIdTokenType) => {
        return {
          officeName: office.office_name,
          officeId: office.office_id,
          staffId: office.staff_id,
          staffName: `${office.last_name}${office.first_name}`,
          maximumUsers: office.maximum_users,
          jihatuMaximumUsers: office.jihatsu_maximum_users,
          hodeiMaximumUsers: office.hodei_maximum_users,
          serviceId: office.service_id,
        }
      }
    )

    return selectOfficeArray
  },
  async isUserAuth(awaitMode = false) {
    const object = {} as {
      [key: string]: boolean | any
    }
    const kumasanInstance = new KumasanAuth()
    await kumasanInstance.authenticate()
    await kumasanInstance.updateIdToken()

    if (awaitMode) {
      await kumasanInstance.updateAwaitIdToken()
    }

    const _idToken = document.cookie.replace(
      /(?:(?:^|.*;\s*)kumasan_idToken\s*=\s*([^;]*).*$)|^.*$/,
      '$1'
    )

    const base64Url = _idToken.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const decode = JSON.parse(decodeURIComponent(escape(window.atob(base64))))
    const response = await handleUnGzipData(
      decode.data.substring(1, decode.data.length - 1)
    )

    object.isAllowUser = false as boolean
    object.isMultipleOffice = false as boolean
    const allStaffArray = response

    // cookie確認
    const officeId = document.cookie.replace(
      /(?:(?:^|.*;\s*)office_id\s*=\s*([^;]*).*$)|^.*$/,
      '$1'
    )
    // officeIdがない場合は未ログイン
    if (officeId === '') {
      // 事業所が一つ
      if (allStaffArray.length === 1) {
        const _day = -1 as number
        const staffId = allStaffArray[0].staff_id
        const officeId = allStaffArray[0].office_id
        const officeName = allStaffArray[0].office_name
        const maximumUsers = allStaffArray[0].maximum_users
        const jihatuMaximumUsers = allStaffArray[0].jihatsu_maximum_users
        const hodeiMaximumUsers = allStaffArray[0].hodei_maximum_users
        const serviceId = allStaffArray[0].service_id

        document.cookie =
          'staff_id' +
          '=' +
          staffId +
          ';domain=' +
          document.domain +
          ';expires=' +
          _day +
          ';path=/;'
        document.cookie =
          'office_id' +
          '=' +
          officeId +
          ';domain=' +
          document.domain +
          ';expires=' +
          _day +
          ';path=/;'
        const res = sessionStorageUtils.handleSetSessionStorage(
          'office',
          encodeURIComponent(officeName)
        )
        sessionStorageUtils.handleSetSessionStorage(
          'maximumUsers',
          maximumUsers
        )

        sessionStorageUtils.handleSetSessionStorage(
          'jihatuMaximumUsers',
          jihatuMaximumUsers
        )

        sessionStorageUtils.handleSetSessionStorage(
          'hodeiMaximumUsers',
          hodeiMaximumUsers
        )

        sessionStorageUtils.handleSetSessionStorage('serviceId', serviceId)
        if (!res) {
          alert(
            'データを正常に取得できませんでした。時間をおいて再度ご利用ください。'
          )
          return
        }
        // 現在、ログインしているスタッフが事業所に在籍中であれば許可
        object.isAllowUser = true
      }

      // 複数事業所
      if (allStaffArray.length >= 2) {
        object.isMultipleOffice = true
        object.officeArray = []
        allStaffArray.forEach(
          (
            office: {
              [key: string]: string
            },
            index: number
          ) => {
            object.officeArray[index] = {
              officeName: office.office_name,
              officeId: office.office_id,
              staffId: office.staff_id,
              staffName: `${office.last_name}${office.first_name}`,
              maximumUsers: office.maximum_users,
              jihatuMaximumUsers: office.jihatsu_maximum_users,
              hodeiMaximumUsers: office.hodei_maximum_users,
              serviceId: office.service_id,
            }
          }
        )
      }
    } else {
      // officeIdがある場合はログイン済み状態
      if (allStaffArray.length !== 0) {
        const staffData = [] as {
          [key: string]: string | number
        }[]

        allStaffArray.forEach((staff: { [key: string]: string }) => {
          if (staff.office_id === officeId) {
            staffData.push(staff)
          }
        })

        // 現在、ログインしているスタッフが事業所に在籍中であれば許可
        if (staffData.length === 1) {
          object.isAllowUser = true
          // ログイン済み状態の場合はログイン中のスタッフ情報をセッションストレージにセット
          const currentStaffRes = sessionStorageUtils.handleSetSessionStorage(
            'currentStaff',
            staffData[0]
          )

          if (!currentStaffRes) {
            alert(
              'データを正常に取得できませんでした。時間をおいて再度ご利用ください。'
            )
            return
          }
        }
      }
    }
    return object
  },

  async isLineUserAuth(awaitMode = false) {
    this.isCheckLineCookie()
    const object = {} as {
      [key: string]: boolean | any
    }
    const kumasanInstance = new KumasanAuth()
    await kumasanInstance.authenticate()
    await kumasanInstance.updateIdToken()

    if (awaitMode) {
      await kumasanInstance.updateAwaitIdToken()
    }

    const _idToken = document.cookie.replace(
      /(?:(?:^|.*;\s*)kumasan_idToken\s*=\s*([^;]*).*$)|^.*$/,
      '$1'
    )

    const base64Url = _idToken.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const decode = JSON.parse(decodeURIComponent(escape(window.atob(base64))))
    const response = await handleUnGzipData(
      decode.data.substring(1, decode.data.length - 1)
    )
    // const response = JSON.parse(decodeURIComponent(escape(window.atob(base64))))

    object.isAllowUser = false as boolean
    object.isMultipleOffice = false as boolean
    object.isUseLine = false as boolean
    const allStaffArray = response

    // cookie確認
    const officeId = document.cookie.replace(
      /(?:(?:^|.*;\s*)line_office_id\s*=\s*([^;]*).*$)|^.*$/,
      '$1'
    )
    // officeIdがない場合は未ログイン
    if (officeId === '') {
      // 事業所が一つ
      if (allStaffArray.length === 1) {
        const _day = -1 as number
        const staffId = allStaffArray[0].staff_id
        const officeId = allStaffArray[0].office_id
        const officeName = allStaffArray[0].office_name
        const maximumUsers = allStaffArray[0].maximum_users
        const jiatsuMaximumUsers = allStaffArray[0].jihatsu_maximum_users
        const hodeiMaximumUsers = allStaffArray[0].hodei_maximum_users

        document.cookie =
          'line_staff_id' +
          '=' +
          staffId +
          ';domain=' +
          document.domain +
          ';expires=' +
          _day +
          ';path=/;'
        document.cookie =
          'line_office_id' +
          '=' +
          officeId +
          ';domain=' +
          document.domain +
          ';expires=' +
          _day +
          ';path=/;'
        const res = sessionStorageUtils.handleSetSessionStorage(
          'office',
          encodeURIComponent(officeName)
        )
        sessionStorageUtils.handleSetSessionStorage(
          'maximumUsers',
          maximumUsers
        )
        sessionStorageUtils.handleSetSessionStorage(
          'jihatuMaximumUsers',
          jiatsuMaximumUsers
        )
        sessionStorageUtils.handleSetSessionStorage(
          'hodeiMaximumUsers',
          hodeiMaximumUsers
        )
        if (!res) {
          alert(
            'データを正常に取得できませんでした。時間をおいて再度ご利用ください。'
          )
          return
        }
        // 現在、ログインしているスタッフが事業所に在籍中であれば許可
        object.isAllowUser = true

        if (allStaffArray[0].line_use_flg === '1') {
          object.isUseLine = true
        }
      }

      // 複数事業所
      if (allStaffArray.length >= 2) {
        object.isMultipleOffice = true
        object.officeArray = []
        allStaffArray.forEach(
          (
            office: {
              [key: string]: string
            },
            index: number
          ) => {
            object.officeArray[index] = {
              officeName: office.office_name,
              officeId: office.office_id,
              staffId: office.staff_id,
              staffName: `${office.last_name}${office.first_name}`,
              maximumUsers: office.maximum_users,
              jihatuMaximumUsers: office.jihatsu_maximum_users,
              hodeiMaximumUsers: office.hodei_maximum_users,
            }
          }
        )
      }
    } else {
      // officeIdがある場合はログイン済み状態
      if (allStaffArray.length !== 0) {
        const staffData = [] as {
          [key: string]: string | number
        }[]

        allStaffArray.forEach((staff: { [key: string]: string }) => {
          if (staff.office_id === officeId) {
            staffData.push(staff)
          }
        })

        // 現在、ログインしているスタッフが事業所に在籍中であれば許可
        if (staffData.length === 1) {
          object.isAllowUser = true

          if (staffData[0].line_use_flg === '1') {
            object.isUseLine = true
          }

          // ログイン済み状態の場合はログイン中のスタッフ情報をセッションストレージにセット
          const currentStaffRes = sessionStorageUtils.handleSetSessionStorage(
            'currentStaff',
            staffData[0]
          )

          if (!currentStaffRes) {
            alert(
              'データを正常に取得できませんでした。時間をおいて再度ご利用ください。'
            )
            return
          }
        }
      }
    }
    return object
  },

  isCheckLineCookie() {
    // cookie確認
    const lineOfficeId = document.cookie.replace(
      /(?:(?:^|.*;\s*)line_office_id\s*=\s*([^;]*).*$)|^.*$/,
      '$1'
    )
    if (!lineOfficeId) {
      const _day = -1
      const officeId = document.cookie.replace(
        /(?:(?:^|.*;\s*)office_id\s*=\s*([^;]*).*$)|^.*$/,
        '$1'
      )
      const staffId = document.cookie.replace(
        /(?:(?:^|.*;\s*)staff_id\s*=\s*([^;]*).*$)|^.*$/,
        '$1'
      )
      if (!officeId) {
        alert('ログインしてください')
        location.href = '/login'
        return
      }

      document.cookie =
        'line_office_id' +
        '=' +
        officeId +
        ';domain=' +
        document.domain +
        ';expires=' +
        _day +
        ';path=/;'

      document.cookie =
        'line_staff_id' +
        '=' +
        staffId +
        ';domain=' +
        document.domain +
        ';expires=' +
        _day +
        ';path=/;'
    }
  },
}
